const useReducer = {
  user: (state = null, { type, payload }) => {
    switch (type) {
      case "LOGIN_USER":
        return payload;
      case "SIGN_OUT":
        return null;
      case "UPDATE_COMPANY_DATA":
        return state ? {
          ...state,
          companyData: {
            ...state.companyData,
            ...payload,
          },
        } : state;
      default:
        return state;
    }
  },
};
export default useReducer;
